export default "__VITE_ASSET__9d85522a__"